const RECOVERY_ACTIVE_KEY = 'recovery_active';
const RECOVERY_STARTED_AT_KEY = 'recovery_started_at';
const LAST_RESET_EMAIL_KEY = 'last_reset_email';
export const PASSWORD_RECOVERY_WINDOW_MS = 5 * 60 * 1000;

const getSupabaseClient = () => import('./supabase').then((module) => module.supabase);

export const getPasswordResetRedirectTo = () => `${window.location.origin}/dashboard?reset=true`;

export const isPasswordRecoveryCallbackUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return Boolean(params.get('code')) || window.location.hash.includes('type=recovery');
};

export const isPasswordRecoveryUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('reset') === 'true' || window.location.hash.includes('type=recovery');
};

export const getPasswordRecoveryTimeRemainingMs = () => {
  const startedAt = Number(localStorage.getItem(RECOVERY_STARTED_AT_KEY) || 0);
  if (!startedAt) return 0;
  return Math.max(0, startedAt + PASSWORD_RECOVERY_WINDOW_MS - Date.now());
};

export const isPasswordRecoveryExpired = () => (
  localStorage.getItem(RECOVERY_ACTIVE_KEY) === 'true' &&
  getPasswordRecoveryTimeRemainingMs() <= 0
);

export const hasPasswordRecoveryState = () => (
  localStorage.getItem(RECOVERY_ACTIVE_KEY) === 'true' &&
  !isPasswordRecoveryExpired()
);

export const markPasswordRecoveryActive = ({ refreshWindow = false } = {}) => {
  localStorage.setItem(RECOVERY_ACTIVE_KEY, 'true');
  if (refreshWindow || isPasswordRecoveryCallbackUrl()) {
    localStorage.setItem(RECOVERY_STARTED_AT_KEY, String(Date.now()));
  }
};

export const clearPasswordRecoveryState = ({ clearEmail = false } = {}) => {
  localStorage.removeItem(RECOVERY_ACTIVE_KEY);
  localStorage.removeItem(RECOVERY_STARTED_AT_KEY);
  if (clearEmail) localStorage.removeItem(LAST_RESET_EMAIL_KEY);
};

export const rememberPasswordResetEmail = (email) => {
  if (email) localStorage.setItem(LAST_RESET_EMAIL_KEY, email);
};

export const getRememberedPasswordResetEmail = () => localStorage.getItem(LAST_RESET_EMAIL_KEY);

export const isCodeVerifierMissingError = (error) => {
  const message = error?.message?.toLowerCase() || '';
  return error?.code === 'pkce_code_verifier_not_found' ||
    message.includes('code verifier') ||
    message.includes('verifier not found');
};

export const cleanAuthCallbackUrl = ({ keepReset = false } = {}) => {
  const url = new URL(window.location.href);
  url.searchParams.delete('code');
  if (keepReset) {
    url.searchParams.set('reset', 'true');
  } else {
    url.searchParams.delete('reset');
  }
  url.hash = '';

  window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
};

export const getActiveAuthSession = async () => {
  const supabase = await getSupabaseClient();
  const code = new URLSearchParams(window.location.search).get('code');

  if (code) {
    const { data, error } = await supabase.auth.exchangeCodeForSession(code);
    return { session: data?.session || null, error };
  }

  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (session) return { session, error: null };
  return { session: null, error: null };
};
